module.exports = __webpack_public_path__ + "img/symbol_4.23d34456.png";